import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as productivityActions from '../../store/actions/productivity';
import { actions as fieldActions } from '../../store/dux/fields-dux';
import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import Map from './Map';
import FieldProductivity from './FieldProductivity';
import { Section } from '../Section';

const PotentialProductivity = (props) => {
  const {
    growerId,
    isLoading,
    fields,
    getFieldProductivity,
    selectFields,
    selectedFields,
    username,
    isAdministrator,
    setApproval,
  } = props;

  React.useEffect(() => {
    if (growerId) getFieldProductivity(growerId);
  }, [getFieldProductivity, growerId]);

  return (
    <Section>
      <ResizablePanel
        topPanel={buildTopPanel()}
        bottomPanel={buildBottomPanel()}
      />
    </Section>
  );

  function buildTopPanel() {
    return <Map />;
  }

  function buildBottomPanel() {
    return (
      <FieldProductivity
        fields={fields}
        getFieldProductivity={getFieldProductivity}
        growerId={growerId}
        isAdministrator={isAdministrator}
        isLoading={isLoading}
        selectFields={selectFields}
        selectedFields={selectedFields}
        setApproval={setApproval}
        username={username}
      />
    );
  }
};

const mapStateToProps = (state) => {
  const { productivity, fields, growerOperations, auth } = state;

  return {
    growerId:
      growerOperations && growerOperations.selectedGrowerOperation
        ? growerOperations.selectedGrowerOperation.guid
        : '',
    growerOperations: auth ? auth.growers || [] : [],
    isAdministrator: auth.userType === 'administrator',
    isLoading: productivity.isLoading,
    fields: productivity.fields || [],
    selectedFields: fields.selectedGrowerFields || [],
    username: auth.username,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getFieldProductivity: productivityActions.loadProductivityForGrower,
      selectFields: fieldActions.setSelectedGrowerFields,
      setApproval: productivityActions.setApproval,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PotentialProductivity);
